export const environment = {
  production: false, 
  DomainURL: "https://oanhho.sohu.vn/",  
  DomainDestination: "https://oanhho.sohu.vn/#/",  
  APIURL: "https://api.oanhho.sohu.vn/api/v1/",    
  APIRootURL: "https://api.oanhho.sohu.vn/",    
  LoginURL: "https://login.oanhho.sohu.vn/",
  Website: "https://oanhho.sohu.vn/",
  Image: "Image",  
  Company: "Company", 
  Membership: "Membership", 
  Barcode: "Barcode",
  QRcode: "QRcode",
  OrderDelivery: "OrderDelivery", 
  OrderCall: "OrderCall", 
  Download: "Download",  
  LoadingFile: "loading.gif",
  DialogConfigWidth: "80%",
  InitializationString: "",  
  InitializationNumber: 0, 
  DieuHanhID: 2, 
  ShopID: 3, 
  ShipperID: 4, 
  AuthenticationToken: "AuthenticationToken",
  MembershipID: "MembershipID",  
  UploadSuccess: "Upload thành công.",
  UploadNotSuccess: "Upload không thành công.", 
  SaveSuccess: "Lưu thành công.",
  SaveNotSuccess: "Lưu không thành công.",  
  DeleteConfirm: "Bạn muốn xóa dữ liệu này?",      
  DeleteSuccess: "Xóa thành công.",
  DeleteNotSuccess: "Xóa không thành công.",    
  LoginNotSuccess: "Đăng nhập không thành công.",    
  UserNameExists: "UserName đã tồn tại.",
  UserNameRequired: "UserName là bắt buộc.",    
};

